module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('div', {
    staticClass: "d-flex fd-column flex-1"
  }, [(_vm.modoLista) ? _c('div', _vm._l((5), function(a) {
    return _c('div', [_c('v-skeleton-loader', {
      attrs: {
        "type": "list-item-avatar-two-line"
      }
    }), _c('v-skeleton-loader', {
      attrs: {
        "type": "divider"
      }
    })], 1)
  }), 0) : _c('div', [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-two-line"
    }
  })], 1)]) : _c('div', [(_vm.modoLista) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "dense",
      "nav": "nav"
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "active-class": "primary--text",
      "mandatory": "mandatory"
    },
    on: {
      "change": _vm.seleccionarUsuario
    },
    model: {
      value: (_vm.seleccionado),
      callback: function($$v) {
        _vm.seleccionado = $$v
      },
      expression: "seleccionado"
    }
  }, [_vm._l((_vm.lista), function(e, index) {
    return [_c('v-list-item', {
      key: index,
      attrs: {
        "value": e
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;

          return [_c('v-list-item-avatar', [_c('img', {
            attrs: {
              "src": e.foto ? e.foto : '/static/nobody.jpg'
            }
          })]), _c('v-list-item-content', [_c('v-list-item-title', [_c('span', {
            staticClass: "font-weight-700"
          }, [_vm._v(_vm._s(e.nombre))])]), _c('v-list-item-subtitle', [_c('span', {
            staticClass: "font-size-11"
          }, [_vm._v(_vm._s(e.cargo))])])], 1)]
        }
      }], null, true)
    })]
  })], 2)], 1) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.lista,
      "loading": _vm.isLoading,
      "disabled": _vm.isLoading,
      "item-text": "usuario",
      "label": _vm.multiple ? 'Selecciona varias opciones' : 'Selecciona una opcion',
      "placeholder": "Ingrese un nombre para buscar",
      "return-object": "",
      "dense": "dense",
      "chips": "chips",
      "solo": _vm.noSolo,
      "hide-details": "hide-details",
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.seleccionarUsuario
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', _vm._b({
          staticClass: "pa-4 ma-1",
          attrs: {
            "color": "background",
            "close": "close",
            "input-value": data.selected
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              data.select, _vm.showModal(data.item)
            },
            "click:close": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, 'v-chip', data.attrs, false), [_c('v-avatar', {
          attrs: {
            "left": ""
          }
        }, [_c('v-img', {
          attrs: {
            "src": data.item.foto ? data.item.foto : '/static/nobody.jpg'
          }
        })], 1), _c('div', {
          staticClass: "d-flex fd-column line-height-title"
        }, [_c('span', {
          staticClass: "font-weight-700"
        }, [_vm._v(_vm._s(data.item.nombre))]), _c('small', {
          staticClass: "blue--text font-size-11"
        }, [_vm._v(_vm._s(data.item.perfil))])])], 1)]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": data.item.foto ? data.item.foto : '/static/nobody.jpg'
          }
        })]), _c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-size-12 font-weight-700",
          domProps: {
            "innerHTML": _vm._s(data.item.nombre)
          }
        }), _c('v-list-item-subtitle', [_c('div', {
          staticClass: "d-flex"
        }, [_c('span', {
          staticClass: "font-size-12"
        }, [_vm._v(_vm._s(data.item.usuario))]), _c('span', {
          staticClass: "font-size-11 ml-3 primary--text"
        }, [_vm._v("(" + _vm._s(data.item.perfil) + ")")])])])], 1), (data.item.rutaSctr) ? _c('v-list-item-action', [_c('v-btn', {
          attrs: {
            "fab": "fab",
            "color": "white primary--text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.verPdfSctr(data.item.rutaSctr)
            }
          }
        }, [_c('v-icon', [_vm._v("picture_as_pdf")])], 1)], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.seleccionado),
      callback: function($$v) {
        _vm.seleccionado = $$v
      },
      expression: "seleccionado"
    }
  }), _c('v-dialog', {
    attrs: {
      "bottom": "",
      "width": "400",
      "right": "",
      "transition": "scale-transition",
      "origin": "top left"
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-card', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.usuarioDetalles.foto ? _vm.usuarioDetalles.foto : '/static/nobody.jpg',
      "contain": "contain",
      "max-height": "400"
    }
  }), _c('v-list', {
    attrs: {
      "color": "primary",
      "dark": "dark",
      "dense": "dense"
    }
  }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.usuarioDetalles.nombre))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.usuarioDetalles.usuario) + " - " + _vm._s(_vm.usuarioDetalles.cargo))])], 1), (_vm.usuarioDetalles.rutaSctr) ? _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "color": "white primary--text"
    },
    on: {
      "click": function($event) {
        return _vm.verPdfSctr()
      }
    }
  }, [_c('v-icon', [_vm._v("picture_as_pdf")])], 1)], 1) : _vm._e()], 1), (_vm.showChangeFoto) ? _c('v-list-item', [_c('v-list-item-content', [_c('v-btn', {
    attrs: {
      "small": !_vm.isMovil,
      "block": "block",
      "color": "white primary--text"
    },
    on: {
      "click": function($event) {
        return _vm.seleccionarFotoPerfil()
      }
    }
  }, [_vm._v("Cambiar foto de perfil")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85c83898","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_usuarios_lista_seleccionar.vue
// module id = 518
// module chunks = 1